import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer"
    exact
    path="/consumer"
    component={AsyncPage}
    breadcrumb={[
      {
        position: 1,
        name: 'Home',
        item: '/consumer',
      },
    ]}
  />,
];
